export default {
    state: {
        verificationCodeMobileRes: false,   // 手机号
        verificationCodeEmailRes: false,   // 邮箱
    }
  }
  